import { SettingsRouter } from "pages/admin/MyProxiesPage/components/SettingsRouter/SettingsRouter";
import cn from "classnames"
import style from "./SettingsCell.module.scss";
import { IProxy } from "@interfaces/admin/proxy";
import { useState } from "react";
import { DeleteModemButton } from "./DeleteModemButton";

export function SettingsCell({
    data
}: {
    data: IProxy
}) {
    const [isOpen, setIsOpen] = useState<boolean>(false);

    return (
        <>
            <div className={cn(style.cell, "items-center gap-2")}>
                <button type="button" aria-label="Налаштування модема"
                    onClick={() => setIsOpen(state => !state)} className="p-1 rounded focus-visible:outline">
                <svg
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg" width="21" height="5" viewBox="0 0 21 5" fill="none">
                    <rect width="5" height="5" rx="2.5" fill="#A2AFD0" />
                    <rect x="8" width="5" height="5" rx="2.5" fill="#A2AFD0" />
                    <rect x="16" width="5" height="5" rx="2.5" fill="#A2AFD0" />
                </svg>
                </button>
                <DeleteModemButton data={data} />
            </div>
            <SettingsRouter proxyId={data.router_id} isOpen={isOpen} close={() => setIsOpen(false)}/>
        </>
    )
}
